import axios from 'axios'
import { getToken, setToken, getRefreshToken, setRefreshToken, removeToken, removeRefreshToken } from '@/utils/auth'
import { refreshAccessToken } from '@/api/user'
import { ElMessage } from 'element-plus'
import router from '../router'
import { userStore } from '../stores/user'


console.log('baseapi', process.env.VUE_APP_AUTH_API, process.env);

const service = axios.create({
  baseURL: process.env.VUE_APP_AUTH_API, // url = base url + request url
  timeout: 120000 // request timeout
})


export function post(url, data) {
  return service.post(url, data);
}


// request interceptor
service.interceptors.request.use(

  
  config => {
    const token = getToken();
    // console.log('token', token)
    if (token) {
      
      config.headers['Authorization'] = `Bearer ${token}`;

    }
    return config
  },
  error => {
    // do something with request error
    console.log('request err', error) // for debug
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {

    return response.data   
  },
  async error => {
    console.log('err:', error) // for debug
    if (error && error.response && error.response.data && error.response.data.status == 401 && error.response.data.name === "invalid_token") {
      console.log('invalid token')
      const config = error.response.config;
      const refreshToken = getRefreshToken();
      removeToken();
      try {
        if (refreshToken) {
          const result = await refreshAccessToken(refreshToken);
          setToken(result.accessToken)
          setRefreshToken(result.refreshToken)
          return service(config);
        }
        else {
          removeRefreshToken();
          throw 'token refresh failed';
        }
      }
      catch (e) {
        return Promise.reject(e.response ? e.response.data : e);
      }

    }
    else {
      if (error.response.status === 400 || error.response.status === 401) {
        // token过期,请重新登录!
        // ElMessage.error('token timeout')
        if (error.response.data?.code == 40112) {
          console.log('code error');
        }
        else {

          userStore().logout();
          router.push("/login")
        }
      }
      return Promise.reject(error.response ? error.response.data : error);
    }

  }
)

export default service
